<template>
  <div class="overflow-hidden flex items-center justify-center bg-black">
    <step-one v-if="step == 1" @next="nextStep"> </step-one>
    <step-two v-if="step == 2" @next="nextStep"> </step-two>
    <step-three v-if="step == 3"> </step-three>
  </div>
</template>
<script>
// import accountCard from "./account.vue";
import stepOne from "./components/AddStepOne.vue";
import stepTwo from "./components/AddStepTwo.vue";
import stepThree from "./components/AddStepThree.vue";
export default {
  components: {
    // accountCard,
    stepOne,
    stepTwo,
    stepThree,
  },
  data() {
    return {
      title: null,
      step: 1,
    };
  },
  methods: {
    nextStep() {
      this.step += 1;
    },
  },
  beforeMount() {
    this.title = this.$route.meta.prtitle;
  },
  mounted() {},
};
</script>
